const actionsTransitionDurationMs = 100;
const wrapper = "_61w1u1m59";
const selectWrapper = "_61s1510251";
const select = "_61s12v4mia";
const closeEditMode = "_61c10g2lpn";
const actionsTransitionWrapper = "_61a1svjdk5";
const actionsWrapper = "_61a133940a";
const narrowPill = "_61nuvjzcq";

export { actionsTransitionDurationMs, actionsTransitionWrapper, actionsWrapper, closeEditMode, narrowPill, select, selectWrapper, wrapper };
import "./revisions.style.linaria.module.css";
//# sourceMappingURL=revisions.style.js.map
